@if (purchaseRequisitionId) {
  <button class="btn btn-sm btn-info font-08" (click)="openDialog()">
    <ng-content></ng-content>
  </button>
}
